import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=15a4f3ba&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=15a4f3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4f3ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a4f3ba')) {
      api.createRecord('15a4f3ba', component.options)
    } else {
      api.reload('15a4f3ba', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=15a4f3ba&scoped=true&", function () {
      api.rerender('15a4f3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VeK1bfkI509V/JS/teamMember.vue"
export default component.exports